/**
 * Description: 根元素px大小设置 【便于像素(px)、rem单位转换计算】
 * 计算公式: 页面宽度 * 100 / 设计图宽度，设计图一般采用750px。
 */
function pxToRem(){
    var oHtml = document.getElementsByTagName("html")[0];
    var oBody = document.getElementsByTagName("body")[0];
    var psdsize = 750;  //这里表示我设计图的宽度 
    //计算字体大小
    var htmlfont = oBody.offsetWidth / psdsize * 100 + 'px';
    oHtml.style.fontSize = htmlfont;
    oBody.style.opacity = '1';  //听说是为了兼容IE

    //监听事件
    window.onresize = function() {
        var oHtml = document.getElementsByTagName("html")[0];
        var oBody = document.getElementsByTagName("body")[0];
        var psdsize = 750;  //这里表示我设计图的宽度 
        htmlfont = oBody.offsetWidth / psdsize * 100 + 'px';
        oHtml.style.fontSize = htmlfont;
    };

    window.onload = function(){
        // 隐藏页面loading
        var oApp = document.getElementById("load-img");
        oApp.className = 'hide';
    }
}
export {
    pxToRem
}



// WEBPACK FOOTER //
// ./src/common/js/pxToRem.js